'use strict';

const _ = require('lodash');

const promotionFeatureFlagNames = [
    'canWriteParkingLotPromotion',
    'canEditParkingLotPromotion',
    'canCreatePromotion',
    'canCreateSplitPromotion',
    'canDeletePromotion',
    'canDeleteParkingLotPromotion',
    'canEditInFlightPromotion',
    'canEditPromotionAssignedToSubmittedResource',
    'canUnlockPromotion',
    'canRequestUnlockPromotion',
    'canCreateStoreWidePromotion',
    'canCreateCategoryWidePromotion',
    'canReadPromotion',
    'canEditApprovedPromotion',
    'canManuallyExecutePromotion',
    'canManuallyValidatePromotion',
    'maxNumberOfAlternativeMechanics',
    'allowAlternativeMechanics',
];

const channelFeatureFlagNames = ['canEditChannel'];

// Used to match keys in toggle-logic with feature flag checks in the code

const featureFlagNames = [
    'explicitlyAllow',
    'noRestriction',
    'apportioningFunction',
    'calculateMarginFunction',
    'calculateFundingFunctions',
    'supplierCommitmentsFilterFunction',
    'supplierCommitmentsAccessFunction',
    'canEditCampaign',
    'canEditLiveCampaigns',
    'canEditSubCampaign',
    'canEditLiveSubCampaigns',
    'allowAdminToEditLiveCampaigns',
    'canEditScenario',
    'canEditLiveScenarios',
    'canCreateScenario',
    'canReadScenario',
    'canEditPromotion',
    'canDeleteScenario',
    'canCopyScenario',
    'canAccessPlanning',
    'canAccessPreparation',
    'canAccessLanding',
    'canAccessSupplierPage',
    'canAccessReporting',
    'canAccessProductsPage',
    'canAccessProxyProducts',
    'canAccessProductGroups',
    'disablePromotionEditingDaysBeforeStart',
    'promotionDatesOutsideScenario',
    'disablePromotionEditingWhenAssignedToPromoResource',
    'showJsonExportButton',
    'disablePromotionEditingWhenParentNotApproved',
    'disablePromotionEditingWhenPromotionNotInManualMode',
    'disablePromotionEditingOnWorkflowStates',
    'disablePromotionEditingOnResourceWorkflowStates',
    'disablePromoResourceEditingOnWorkflowStates',
    'promotionAllocationFilterFunction',
    'enablePublicPrivateEntities',
    'enableProductLevelSellInPeriod',
    'enableSplitPromotions',
    'canAccessAllCategories',
    'canAccessAllStoreGroups',
    'canAccessPromotionsWithoutStoreGroups',
    'canAccessPrivateCampaigns',
    'canAccessPrivateSubCampaigns',
    'canAccessPrivateScenarios',
    'canPublishCampaigns',
    'canPublishSubCampaigns',
    'canPublishScenarios',
    'dateValidatorFunction',
    'numberFilterFunction',
    'channelsStoresValidatorFunction',
    'mechanicValidatorFunction',
    'productsValidatorFunction',
    'supplyValidatorFunction',
    'offerValidatorFunction',
    'subCampaignOrdering',
    'supplierValidatorFunction',
    'numberOfEffectivenessRatingColours',
    'effectivenessRatingCalculationMethod',
    'disableCampaignCreationDaysBeforeToday',
    'disableCampaignEditingDaysBeforeStart',
    'disableSubCampaignEditingDaysBeforeStart',
    'disableScenarioEditingDaysBeforeStart',
    'disablePromoResourceEditingDaysBeforeSubCampaignStart',
    'stateIconsMap',
    'workflowConfirmationFields',
    'workflowAlertGrouping',
    'firstWeekCalendarViewRestriction',
    'lastWeekCalendarViewRestriction',
    'supplierCommitmentOptions',
    'canAccessRateCards',
    'canModifyRateCards',
    'canAccessParkingLot',
    'canAccessAdminArea',
    'canAccessAdminAreaOrClientSystemsTesting',
    'canAccessAdminTools',
    'canApplyChangesForLivePromotions',
    'hiddenParkingLotColumns',
    'includeGhostsOnOverviewPage',
    'enableParentChildModule',
    'enablePromotionPermalink',
    'canEditBookmarks',
    'promotionNameIsRequired',
    'rankTabPriceField',
    'rankTabColumnsConfig',
    'weightOptions',
    'canEditListPrice',
    'canAccessClientSystemsTesting',
    'allVariantsFlag',
    'useClientStateFilter',
    'enableOfferCommercialField',
    'promotionAccessFunction',
    'autoOpenSupplierCommitmentDialogInFunding',
    'canViewScenariosFrontEnd',
    'autoReforecastPromotions',
    'hideProductsWithCategoriesUserHasNoAccessTo',
    'forbidToDragProductsWithCategoriesUserHasNoAccessTo',
    'deletePromotionFromExecutionSystem',
    'restrictAccessByStoreGroups',
    'restrictAccessByCategories',
    'enableDownloadCentre',
    'reportingOnly',
    'reportingManagementRole',
    'reportFilters',
    'productFilterExcludedFields',
    'excludedAttributes',
    'defaultAttributes',
    'showOnlyMinPrices',
    'defaultRoute',
    'defaultAdminTab',
    'canAccessUserDocs',
    'useNewCostStructure',
    'showSingleTrip',
    'showIncrementalKPIs',
    'allowZeroRateCardAmount',
    'maxChildNumberToShowVolumesInParent',
    'allowApplyAllNotifications',
    'allowApplyAllNotificationsDialog',
    'allowCategoryWidePromotions',
    'allowStoreWidePromotions',
    'allowValidationSeverities',
    'pagination',
    'rateCardsAtSubCampaignLevel',
    'canUpdatePromotionPublishingMode',
    'couponLinkedWithCommercialField',
    'allowAttrbuteScopePromotions',
    'useDynamicAttributeFiltering',
    'enableAttributeRangeMode',
    'enableAttributeValueExclusionFiltering',
    'enableMultipleAttributeSegments',
    'disableDefaultResourceBehavior',
    'offerMechanicPresetOrder',
    'enablePriceTags',
    'enableOfferPresetsAdmin',
    'canManageOfferMechanicPresets',
    'onlyPresetOfferMechanicsEditable',
    'showPromotionWorkflowIcon',
    ...promotionFeatureFlagNames,
    ...channelFeatureFlagNames,
];

const featureFlags = _.zipObject(featureFlagNames, featureFlagNames);

module.exports = featureFlags;
